var render, staticRenderFns
import script from "./Association.vue?vue&type=script&lang=js&"
export * from "./Association.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c113698",
  null
  
)

export default component.exports